
import Panel from 'vux/src/components/panel/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {Dialog} from "vant";

export default {
components: {
Panel,
Cell
},
data() {
return {
apiurl: "",
deviceList: []
};
},

created() {},

beforeMount() {},

mounted() {
let _this = this
_this.$http.get("./static/api/api.json").then(response => {
_this.apiurl = response.api;
_this.getList();
});
},
methods: {
goEdit(id){
this.$router.push({
path: "/deviceEdit",
query: {
deviceId: id
}
});
},
goWallet(){
this.$router.push({
name: "wallet",
});
},
renew(id){
Dialog.confirm({
title: '续费',
message: '确定立即续费吗？',
})
.then(() => {

const routerData = {
deviceId: id
}
this.$router.push({
name: "payment",
params: {
data: JSON.stringify(routerData)
}
});
})
.catch(() => {

});
},
setting(id){
const routerData = {
deviceId: id
}
this.$router.push({
name: "setting",
params: {
data: JSON.stringify(routerData)
}
});
},
goMap(lat,lng,name){
const routerData = {
lat: lat,
lng: lng,
name: name
}
this.$router.push({
name: "map",
params: {
data: JSON.stringify(routerData)
}
});
},
warning(id){
Dialog.confirm({
title: '报警',
message: '确定立即报警吗？',
})
.then(() => {

this.$http
.post(this.apiurl + "/web/device/alarm/" + id)
.then((res) => {
if (res.code === 0) {
this.$vux.toast.text("操作成功", "top");
this.getList()
}else {
this.$vux.toast.text(res.message, "top");
}
});
})
.catch(() => {

});
},
deleteDevice(id){
Dialog.confirm({
title: '删除',
message: '确定删除此设备吗？',
})
.then(() => {

this.$http
.delete(this.apiurl + "/web/device/del/" + id)
.then((res) => {
if (res.code === 0) {
this.$vux.toast.text("操作成功", "top");
this.getList()
}else {
this.$vux.toast.text(res.message, "top");
}
});
})
.catch(() => {

});
},
getList() {
this.$http
.get(this.apiurl + "/web/device/list")
.then((res) => {
if (res.code === 0) {
this.deviceList = res.data;
}
});
},
goDetails(id) {
const routerData = {
deviceId: id
};
this.$router.push({
name: "deviceInfo",
params: {
data: JSON.stringify(routerData)
}
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/deviceList.vue